import { render, staticRenderFns } from "./BulkUpdateDiff.vue?vue&type=template&id=c3810cc8&"
import script from "./BulkUpdateDiff.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateDiff.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpdateDiff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports